import React from 'react';

export function MaterialStocks() {
    return <div>MaterialStocks</div>;
}
